/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { EsercenteImportazioneCandidateDTO } from '../model/esercente-importazione-candidate-dto';
// @ts-ignore
import { EsercenteImportazioneForm } from '../model/esercente-importazione-form';
// @ts-ignore
import { EsercenteImportazionePropostaDTO } from '../model/esercente-importazione-proposta-dto';
// @ts-ignore
import { EsercenteImportazioneRisultatoDTO } from '../model/esercente-importazione-risultato-dto';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { RichiestaPraticaEsercenteStatus } from '../model/richiesta-pratica-esercente-status';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    GestioneImportazioneDomandeEsercenteDaAltroBandoServiceInterface,
    GetPropostaImportazioneEsercenteRequestParams,
    ImportaEsercentiDaAltroBandoRequestParams,
    ListCandidateImportazioneEsercentiRequestParams
} from './gestione-importazione-domande-esercente-da-altro-bando.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class GestioneImportazioneDomandeEsercenteDaAltroBandoService extends BaseService implements GestioneImportazioneDomandeEsercenteDaAltroBandoServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Proposta di clone di una domanda sul form di questo bando.
     * Valori mappati per chiave (system field dall\&#39;anagrafica della domanda, custom per chiave uguale e categoria compatibile), negozi, allegati copiabili (solo file dell\&#39;esercente, mai documenti di sistema), mancanti e campi non mappati, piu\&#39; ragione sociale, P.IVA e tutti i punti vendita dell\&#39;esercente con selezionato. Il bando di origine e\&#39; quello della domanda. Stessi gate dell\&#39;elenco; 404 se la domanda non esiste, e\&#39; su un bando che il chiamante non puo\&#39; consultare, o l\&#39;esercente e\&#39; fuori perimetro. Consensi e dichiarazioni non si copiano.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/importazione/proposta
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getPropostaImportazioneEsercente(requestParameters: GetPropostaImportazioneEsercenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EsercenteImportazionePropostaDTO>;
    public getPropostaImportazioneEsercente(requestParameters: GetPropostaImportazioneEsercenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EsercenteImportazionePropostaDTO>>;
    public getPropostaImportazioneEsercente(requestParameters: GetPropostaImportazioneEsercenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EsercenteImportazionePropostaDTO>>;
    public getPropostaImportazioneEsercente(requestParameters: GetPropostaImportazioneEsercenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getPropostaImportazioneEsercente.');
        }
        const daPraticaEsercente = requestParameters?.daPraticaEsercente;
        if (daPraticaEsercente === null || daPraticaEsercente === undefined) {
            throw new Error('Required parameter daPraticaEsercente was null or undefined when calling getPropostaImportazioneEsercente.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'da_pratica_esercente',
            <any>daPraticaEsercente,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pratiche-esercente/importazione/proposta`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<EsercenteImportazionePropostaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Importa domande esercente da un altro bando.
     * Body {da_tipo_pratica, pratiche_ids[1..25]}: una transazione per domanda, esito per riga {pratica_origine_id, esito CREATA|SALTATA|ERRORE, motivo (NON_TROVATA, INCOMPLETA, GIA_PRESENTE, NESSUN_NEGOZIO, ESERCENTE_BLOCCATO), errore_codice, pratica_creata_id, codice_pratica, mancanti} e contatori. Le domande create nascono SOTTOMESSE (inserita_da_operatore, clonata_da) e l\&#39;esercente riceve l\&#39;avviso email dopo il commit di ciascuna. Gate generali una volta, prima delle righe: 422 se origine &#x3D; destinazione, lista vuota o oltre 25.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/importazione
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public importaEsercentiDaAltroBando(requestParameters: ImportaEsercentiDaAltroBandoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EsercenteImportazioneRisultatoDTO>;
    public importaEsercentiDaAltroBando(requestParameters: ImportaEsercentiDaAltroBandoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EsercenteImportazioneRisultatoDTO>>;
    public importaEsercentiDaAltroBando(requestParameters: ImportaEsercentiDaAltroBandoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EsercenteImportazioneRisultatoDTO>>;
    public importaEsercentiDaAltroBando(requestParameters: ImportaEsercentiDaAltroBandoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling importaEsercentiDaAltroBando.');
        }
        const esercenteImportazioneForm = requestParameters?.esercenteImportazioneForm;
        if (esercenteImportazioneForm === null || esercenteImportazioneForm === undefined) {
            throw new Error('Required parameter esercenteImportazioneForm was null or undefined when calling importaEsercentiDaAltroBando.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pratiche-esercente/importazione`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<EsercenteImportazioneRisultatoDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: esercenteImportazioneForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Domande del bando di origine importabili su questo bando.
     * Elenco completo (non paginato) delle domande del bando da_tipo_pratica negli stati richiesti (stato ripetibile; default ABILITATA), con il verdetto di importabilita\&#39; sul bando del path: completa, mancanti (chiavi) ed eventuale esclusa_motivo (ESERCENTE_BLOCCATO, GIA_PRESENTE_SU_DESTINAZIONE, NESSUN_NEGOZIO). Gate: checkTipoPratica(path, GESTIONE), checkTipoPratica(origine, CONSULTAZIONE), canale operatore del bando del path (flag spento &#x3D; 404, stato non partecipabile &#x3D; 409). 422 se origine &#x3D; destinazione o piu\&#39; di 1000 domande.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/importazione/candidate
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listCandidateImportazioneEsercenti(requestParameters: ListCandidateImportazioneEsercentiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EsercenteImportazioneCandidateDTO>;
    public listCandidateImportazioneEsercenti(requestParameters: ListCandidateImportazioneEsercentiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EsercenteImportazioneCandidateDTO>>;
    public listCandidateImportazioneEsercenti(requestParameters: ListCandidateImportazioneEsercentiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EsercenteImportazioneCandidateDTO>>;
    public listCandidateImportazioneEsercenti(requestParameters: ListCandidateImportazioneEsercentiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listCandidateImportazioneEsercenti.');
        }
        const daTipoPratica = requestParameters?.daTipoPratica;
        if (daTipoPratica === null || daTipoPratica === undefined) {
            throw new Error('Required parameter daTipoPratica was null or undefined when calling listCandidateImportazioneEsercenti.');
        }
        const stato = requestParameters?.stato;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'da_tipo_pratica',
            <any>daTipoPratica,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'stato',
            <any>stato,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pratiche-esercente/importazione/candidate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<EsercenteImportazioneCandidateDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
